module.exports = __webpack_public_path__ + "img/cash_bundle_debt.1104c255.png";